import type { Provider } from '@vgtv/api-client';

import type { AdnConfig } from '../types';

const configAb: AdnConfig<Provider.AB> = {
  live_studio: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-${device}-studio_${format}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    formats: {
      preroll: true,
      bumper: true,
    },
    keywords: {
      pageType: 'front',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
  },
  ab: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-${device}-${section}-${format}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    formats: {
      preroll: true,
      bumper: true,
      pause: true,
      midroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
    glimr: {
      enabled: true,
      keywordPrefix: 'se-generic',
      country: 'se',
      clientId: 'H3IYO2A4LD43YPFZIJLN',
    },
  },
  abtv: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-${device}-${section}-${format}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    formats: {
      preroll: true,
      bumper: true,
      pause: true,
      midroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
    glimr: {
      enabled: true,
      keywordPrefix: 'se-generic',
      country: 'se',
      schibstedAdChoicesEnabled: true,
      clientId: 'H3IYO2A4LD43YPFZIJLN',
    },
  },
  malservice: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-tv-${device}-sportbladet_${format}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    formats: {
      preroll: true,
      bumper: true,
      pause: true,
      midroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
  },
};

const configSvd: AdnConfig<Provider.SVD> = {
  svd: {
    member: 9943,
    invCodeTemplate: 'se-svd-tv-${device}-${format}',
    afpTemplate: 'se-svd-tv-${device}-afp-${format}',
    formats: {
      preroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'svd',
      publisherGroup: 'schibsted',
    },
  },
};

export { configAb, configSvd };
